import { supabase } from "./supabase";
export async function uploadInvitationAudio(file: File): Promise<string> {
  if (!/\.mp3$/i.test(file.name) || (file.type && !["audio/mpeg","audio/mp3"].includes(file.type))) throw new Error("Choose an MP3 audio file.");
  if (file.size < 4 || file.size > 15 * 1024 * 1024) throw new Error("Choose an MP3 file up to 15 MB.");
  const bytes=new Uint8Array(await file.slice(0,4).arrayBuffer());
  const id3=bytes[0]===73 && bytes[1]===68 && bytes[2]===51;
  const frame=bytes[0]===255 && (bytes[1]&224)===224 && (bytes[1]&6)!==0 && (bytes[2]&240)!==240;
  if(!id3 && !frame) throw new Error("This file does not appear to be an MP3. Choose another file.");
  const {data:{user},error:authError}=await supabase.auth.getUser();
  if(authError || !user) throw new Error("Please sign in again before uploading music.");
  const storage=supabase.storage.from("invitation-audio");
  const path=`${user.id}/${crypto.randomUUID()}.mp3`;
  const {error}=await storage.upload(path,file,{contentType:"audio/mpeg",cacheControl:"31536000",upsert:false});
  if(error) throw new Error("MP3 upload failed. Check that invitation audio storage is set up, then try again. Your saved soundtrack has not changed.");
  return storage.getPublicUrl(path).data.publicUrl;
}
